import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';
import { Button } from '@/components/ui/button';

export default function AppPasswordResetGate() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const nonce = searchParams.get('nonce') || '';

  useEffect(() => {
    if (!nonce) setError('Invalid or expired link.');
  }, [nonce]);

  const continueReset = async () => {
    if (!nonce) return;
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase.functions.invoke('issue-password-reset-link', { body: { nonce } });
      if (error) throw new Error(error.message || 'Failed to continue reset');
      if (!data?.ok) {
        setError(data?.message || 'This link is not valid anymore. Please request a new reset link.');
        return;
      }
      if (!data?.action_link) {
        setError('We were unable to continue your reset. Please request a new link.');
        return;
      }
      window.location.href = data.action_link as string;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to continue reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-soft-light-gray flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6 bg-white p-8 rounded-lg shadow text-center">
        <h2 className="text-2xl font-bold text-slate-gray">Confirm password reset</h2>
        <p className="text-sm text-slate-gray">Click continue to securely proceed.</p>
        {error && <div className="bg-red-50 text-red-500 p-3 rounded-md text-sm">{error}</div>}
        {!error && !nonce && <div className="bg-red-50 text-red-500 p-3 rounded-md text-sm">This link is invalid or expired. Please request a new password reset link.</div>}
        <Button className="w-full" onClick={continueReset} disabled={loading || !nonce}>
          {loading ? 'Continuing…' : 'Continue'}
        </Button>
        <Button className="w-full" variant="ghost" onClick={() => navigate('/password-reset')}>Start over</Button>
      </div>
    </div>
  );
}


